<template lang="html">

	<section class="producto-home -galletas column-center">

		<div class="container container-title animation">
			<!-- <h1 class="big-title animation" id="titulo-split" data-splitting="chars">{{$t('header.galletas')}}</h1> -->
			<h2 class="big-title animation" id="titulo-split">{{$t('header.galletas')}}</h2>
		</div>

		<div class="contenedor-ruleta">


			<router-link :to="'/'+$i18n.locale+'/'+$t('enlaces.chocolate')" :activo="select == 'chocolate'" @mouseover.native="select = 'chocolate'" class="boton" data="chocolate">
				<img :src="'/static/img/logos/chocolate-home-w-'+$i18n.locale+'.png'" alt="logo galleta chocolate-home-w">

			</router-link>

			<a target="_blank" :href="'https://passionforfabs.com/'" :activo="select == 'fabs'" @mouseover="select = 'fabs'" class="boton" data="premium">
				<img src="/static/img/logos/fabs.png" alt="logo galleta fabs">
			</a>

			<router-link :to="'/'+$i18n.locale+'/'+$t('enlaces.plus')" :activo="select == 'infantil'" @mouseover.native="select = 'infantil'" class="boton" data="infantil">
				<img src="/static/img/logos/bsanplus.svg" alt="logo-header-plus">
			</router-link>

			<router-link :to="'/'+$i18n.locale+'/'+$t('enlaces.adultas')" :activo="select == 'tradicionales'" @mouseover.native="select = 'tradicionales'" class="boton" data="tradicionales">
				<h3 class="column-center">{{$t('sinGluten')}}</h3>
			</router-link>

			<router-link :to="'/'+$i18n.locale+'/'+$t('enlaces.maria')" :activo="select == 'desayuno'" @mouseover.native="select = 'desayuno'" class="boton" data="desayuno">
				<img :src="'/static/img/logos/desayuno-home-w-'+$i18n.locale+'.png'" alt="logo galleta desayuno-home-w">
			</router-link>

			<div class="contenedor-texto">
				<espiral class="espiral-ani" delay="1000"></espiral>
				<p class="yummy waypoints">{{$t('galletasCon')}} <img alt="ilustración de corazón" src="/static/img/corazon.svg" width="90"></p>
			</div>



			<div class="contenedor-imagen row-center">

				<img alt="producto galleta inicial" v-show="select == 'inicial'" class="animated tada" :src="'/static/img/ruleta-home/galletas/inicial.png'">
				<img alt="producto galleta chocolate" v-show="select == 'chocolate'" class="animated tada" :src="'/static/img/ruleta-home/galletas/chocolate.png'">
				<img alt="producto galleta infantil" v-show="select == 'infantil'" class="animated tada" :src="'/static/img/ruleta-home/galletas/infantil.png'">
				<img alt="producto galleta fabs" v-show="select == 'fabs'" class="animated tada" :src="'/static/img/ruleta-home/galletas/fabs.png'">
				<img alt="producto galleta tradicionales" v-show="select == 'tradicionales'" class="animated tada" :src="'/static/img/ruleta-home/galletas/tradicionales.png'">
				<img alt="producto galleta desayuno" v-show="select == 'desayuno'" class="animated tada" :src="'/static/img/ruleta-home/galletas/desayuno.png'">

			</div>

		</div>

		<div class="contenedor-boton">
			<espiral class="espiral-ani" delay="0"></espiral>
			<router-link :to="$t('enlaces.galletas')" class="btn -action waypoints" v-html="$t('todosNuestrasGalletas')"></span></router-link>
		</div>


		<img class="cuchara-madera-blanca" src="/static/img/decoracion-galletas/cuchara-madera-blanca.png" alt="cuchara-madera-blanca">
		<img class="piruleta-naranja-chocolate" src="/static/img/decoracion-galletas/piruleta-naranja-chocolate.png" alt="piruleta-naranja-chocolate">




	</section>

</template>

<script lang="js">

	import espiral from '@/components/parts/icons/espiral'

	export default {
		name: 'modulo-galletas',
		data() {
			return {
				select: 'chocolate',
			}
		},
		components: {
			'espiral': espiral
		}

	}
</script>

<style scoped lang="scss">
	.producto-home {
		background-image: linear-gradient(to bottom, #c9752f, #531c00);
	}

	.cuchara-madera-blanca {
		position: absolute;
		right: -70px;
		top: 30px;
	}

	.piruleta-naranja-chocolate {
		position: absolute;
		left: 0;
		top: 100px;
	}

	.logo-chocolate-lovers {
		max-width: 200px;
		position: absolute;
		bottom: 100px;
		left: 100px;
	}

	.boton {
		&[data=desayuno] {
			right: 0;
			top: 150px;
		}

		&[data=infantil] {
			top: 50%;
			margin-top: 30px;
			right: 0;
			img {				
				width: 140px;
			}
		}

		&[data=tradicionales] {
			bottom: 0;
			left: 50%;
			margin-left: -100px;
		}

		&[data=premium] {
			left: 0;
			top: 50%;
			margin-top: 30px;
		}

		&[data=chocolate] {
			left: 50%;
			margin-left: -100pX;
			top: 0px;
		}
	}

	@for $i from 1 through 7 {
		.boton:nth-child(#{$i}) {
			animation-delay: #{$i / 10 + 1}s;
		}
	}

	h3 {
		font-size: 33px;
		text-transform: uppercase;
		color: #fff;
		font-family: 'Futura LT CondensedExtraBold';
		line-height: 1em;
		transform: rotate(-9deg);

		span {
			font-family: 'Futura LT CondensedExtraBold';
			font-size: 28px;
			line-height: 1em;
		}

		&:hover {
			color: #000;
		}
	}

	.btn {
		font-size: 50px;
		color: #9c541c;
		max-width: fit-content;
		height: 80px;
		line-height: 70px;

		span {
			font-size: 16px;
			color: #9c541c;
		}
	}

	.chocolate-espiral {
		position: absolute;
		right: 80px;
		max-width: 170px;
		top: 100px;
		filter: blur(1px);
	}

	.chocolate-espiral-dos {
		position: absolute;
		right: 80px;
		max-width: 170px;
		bottom: 50px;
		filter: blur(1px);
		transform: rotate(20deg);
	}

	.chocolate-espiral-tres {
		position: absolute;
		left: 80px;
		max-width: 170px;
		top: 300px;
		filter: blur(1px);
		transform: rotate(-20deg);
	}


	.chocolate-espiral-superior {
		position: absolute;
		top: 60px;
		left: 100px;
		max-width: 180px;
		filter: blur(1px);
	}

	.choco-mordida {
		position: absolute;
		bottom: -130px;
		left: 100px;
		max-width: 280px;
	}

	.naranja {
		position: absolute;
		top: -100px;
		left: 200px;
		max-width: 300px;
	}

	.galleta-espelta {
		position: absolute;
		top: 160px;
		right: -80px;
		max-width: 250px;
	}

	.chocolate-inverso {
		position: absolute;
		right: 500px;
		max-width: 400px;
		bottom: -278px;
		filter: blur(1px);
	}

	.contenedor-texto {
		position: absolute;
		left: 0;
		top: 0;
		width: 200px;
		height: 300px;
		padding-top: 200px;
		transform: rotate(20deg);

		.contenedor-espiral {
			position: absolute;
			left: 60px;
			top: 20px;
			transform: scale(.8) rotate(20deg);
		}

		p {
			font-size: 36px;
			color: white;
			display: inline-block;
			line-height: 30px;
			margin-top: 30px;
			animation-delay: 2s;

			img {
				margin-top: 10px;
			}
		}
	}

	@media screen and (max-width: 1100px) {
		.cuchara-madera-blanca {
			display: none;
		}

		.piruleta-naranja-chocolate {
			top: 20px;
			max-width: 300px;
		}
	}

	@media screen and (max-width: 900px) {
		.contenedor-texto {
			display: none;
		}

		.piruleta-naranja-chocolate {
			top: auto;
			bottom: 0px;
			max-width: 200px;
		}

		.logo-chocolate-lovers {
			position: absolute;
			right: 50px;
			bottom: 50px;
			max-width: 110px;
			left: auto;
		}
		.boton {
			&[data=infantil] img {				
				width: 125px;
			}
		} 
	}

	@media screen and (max-width: 520px) {
		.piruleta-naranja-chocolate {
			bottom: 0px;

		}

		.logo-chocolate-lovers {
			bottom: auto;
			top: 100px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/views/home/modulo-galletas.vue